import './styles.css';

import { useTranslation } from 'react-i18next';
import NotificationIcon from 'components/shared/NotificationIcon';
import { NOTIFICATION_STEPS, NOTIFICATION_ROLES_LABELS } from 'utils/Constants';
import { formatNotificationDate, formatDurationSince } from 'utils/DateUtils';

const STEP_LABEL = Object.fromEntries(NOTIFICATION_STEPS.map((s) => [s.id, s.label]));
const PRIORITY_LABEL = { urgent: 'Urgent', reminder: 'Relance' };

// Carte d'une action (lecture seule pour l'instant : boutons et détail à venir)
function NotificationActionCard({ notification: n }) {
  const { t } = useTranslation();

  const isDone = !!n.treated;
  const isUrgent = n.priority === 'urgent';
  const hasPriority = !isDone && PRIORITY_LABEL[n.priority];
  const ageInHours = (new Date() - new Date(n.sent_at)) / 3600000;

  const modifier = isDone ? ' notif-action-card--done' : isUrgent ? ' notif-action-card--urgent' : '';

  // subject peut être vide tant que le microservice des mails ne l'a pas renvoyé
  const subject = n.subject || t('Objet en cours de génération…');

  const actor = n.actor || {};
  const actorRole = actor.role ? ` (${t(NOTIFICATION_ROLES_LABELS[actor.role] || actor.role)})` : '';

  return (
    <article className={`notif-action-card${modifier}`}>
      <span className="notif-step-icon">
        <NotificationIcon name={isUrgent && !isDone ? 'urgent' : n.step} />
      </span>

      <div className="notif-action-card__body">
        <div className="notif-action-card__meta">
          {hasPriority && (
            <span className={`notif-priority notif-priority--${n.priority}`}>{t(PRIORITY_LABEL[n.priority])}</span>
          )}
          {STEP_LABEL[n.step] && <span className="notif-step-label">{t(STEP_LABEL[n.step])}</span>}
          {n.ref_label && (
            <span className="notif-ref" title={n.ref_label}>
              {n.ref_label}
            </span>
          )}
        </div>

        <h3 className={n.subject ? '' : 'notif-action-card__subject--pending'}>{subject}</h3>
        {n.summary && <p className="notif-action-card__summary">{n.summary}</p>}

        <p className="notif-action-card__byline">
          {t('De')} : {actor.name || 'Pixlink'}
          {actorRole} · {formatNotificationDate(n.sent_at)}
          {isDone && (
            <>
              {' '}
              · {t('Traitée')} {formatNotificationDate(n.treated.at).toLowerCase()} {t('par')} {n.treated.by}
              {n.treated.source === 'auto' ? ` (${t('automatique')})` : ''}
            </>
          )}
        </p>
      </div>

      <div className="notif-action-card__side">
        {isDone ? (
          <span className="notif-status notif-status--done">{t('Traitée')}</span>
        ) : (
          <span className={`notif-status${isUrgent ? ' notif-status--urgent' : ''}`}>
            {ageInHours < 24 ? t('Reçue il y a') : t('En attente depuis')} {formatDurationSince(n.sent_at)}
          </span>
        )}
      </div>
    </article>
  );
}

export default NotificationActionCard;
